import React, { useState } from "react";
import styles from "./ConditionalField.module.css";
import SelectField from "../SelectField/SelectField";
import { TextField, StandardTextFieldProps } from "@mui/material";

interface Props 
  extends Omit<StandardTextFieldProps, "value" | "onChange"> {
  label: string;
  value: string;
  onChange: (value: string) => void;
  textFieldValue?: string;
  onTextFieldChange?: (value: string) => void;
  options: { nome: string }[];
  condition: boolean;
  conditionName?: string;
  additionalLabel?: string;
  required?: boolean;
  fullWidth?: boolean;
  customClass?: string;
  selectError?: boolean;
  selectHelperText?: React.ReactNode;
  textError?: boolean;
  textHelperText?: React.ReactNode;
}

const ConditionalField: React.FC<Props> = ({
  label,
  value,
  onChange,
  textFieldValue,
  onTextFieldChange,
  options,
  conditionName = "Outro",
  condition,
  additionalLabel = "Outro",
  required,
  fullWidth,
  customClass,
  selectError,
  selectHelperText,
  textError,
  textHelperText,
}) => {
  const [isTyping, setIsTyping] = useState(false);

  const handleSelectChange = (newValue: string) => {
    if (
      newValue === "Outro" ||
      newValue === "Outras" ||
      newValue === conditionName
    ) {
      onChange(conditionName);
      setIsTyping(true);
    } else {
      onChange(newValue);
      setIsTyping(false);
    }
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onTextFieldChange) {
      onTextFieldChange(event.target.value);
      return;
    }
    onChange(event.target.value);
  };

  return (
    <>
      <SelectField
        fullWidth={fullWidth}
        label={label}
        value={!isTyping ? value : conditionName}
        onChange={handleSelectChange}
        options={options}
        required={required}
        variant="standard"
        error={selectError}
        helperText={selectHelperText}
      />
      {(condition || isTyping) && (
        <div className={styles.showElement}>
          <label className={styles.titleInput}>
            {additionalLabel}
          </label>
          <TextField
            variant="standard"
            size="small"
            label=""
            required={required}
            value={textFieldValue ?? value}
            onChange={handleTextChange}
            onFocus={() => setIsTyping(true)}
            error={textError}
            helperText={textHelperText}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              disableUnderline: true,
              className: customClass,
            }}
          />
        </div>
      )}
    </>
  );
};

export default ConditionalField;
